import { toDateTime } from "Helpers/Format";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome do Responsável",
    accessor: "responsible_name",
  },
  {
    Header: "Nome do Projeto",
    accessor: "project_name",
  },
  {
    Header: "Resumo do Projeto",
    accessor: (row) => row.project_summary,
  },
  {
    Header: "Lei de Incentivo do Projeto",
    accessor: "project_modality",
  },
  {
    Header: "Status",
    accessor: (row) => row.status || "N/A",
  },
  {
    Header: "UFs",
    accessor: (row) => row.ufs,
  },
  {
    Header: "Data de Início",
    accessor: (row) =>
      row.project_start_at ? toDateTime(row.project_start_at) : "",
  },
  {
    Header: "Data de Fim",
    accessor: (row) =>
      row.project_finish_at ? toDateTime(row.project_finish_at) : "",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome do Responsável",
    accessor: "responsible_name",
  },
  {
    Header: "Nome do Projeto",
    accessor: "project_name",
  },
  {
    Header: "Resumo do Projeto",
    accessor: (row) =>
      row.project_summary.length > 30
        ? row.project_summary.substring(0, 30) + "..."
        : row.project_summary,
  },
  {
    Header: "Lei de Incentivo do Projeto",
    accessor: "project_modality",
  },
  {
    // Status do PROJETO (project_statuses). Por `accessor` e sem `Cell`: a busca e
    // a ordenação da tabela leem do accessor, e `Cell` em downloadColumns
    // exportaria JSX no CSV.
    Header: "Status",
    accessor: (row) => row.status || "N/A",
  },
  {
    Header: "UFs",
    accessor: (row) =>
      row.ufs.length > 30 ? row.ufs.substring(0, 30) + "..." : row.ufs,
  },
  {
    Header: "Data de Início",
    accessor: (row) =>
      row.project_start_at ? toDateTime(row.project_start_at) : "",
  },
  {
    Header: "Data de Fim",
    accessor: (row) =>
      row.project_finish_at ? toDateTime(row.project_finish_at) : "",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];
